import * as Communicator from "@ts3d-hoops/web-viewer";
import CallbackManagerExtend from "./callback-manager.extend";

export default class WebViewerExtend extends Communicator.WebViewer {
    callbackManagerExtend: CallbackManagerExtend;
    constructor(inputParams: Communicator.WebViewerConfig) {
        super(inputParams);
        this.callbackManagerExtend = new CallbackManagerExtend();
    }

    setCallbacksExtend(callbacks: Communicator.CallbackMapExtend): void {
        this.callbackManagerExtend.bind(callbacks);
    }
    unsetCallbacksExtend(callbacks: Communicator.CallbackMapExtend): void {
        this.callbackManagerExtend.unbind(callbacks);
    }
}
